import { useCallback, useRef } from 'react';

const DEFAULT_THRESHOLD = 75;

export function useHorizontalSwipeNavigate(
  onNavigate: (delta: number) => void,
  enabled: boolean | (() => boolean) = true,
  threshold = DEFAULT_THRESHOLD
) {
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);
  const touchEndX = useRef(0);
  const touchEndY = useRef(0);

  const isEnabled = () => (typeof enabled === 'function' ? enabled() : enabled);

  const onTouchStart = useCallback(
    (e: React.TouchEvent) => {
      if (!isEnabled()) return;
      touchStartX.current = e.touches[0].clientX;
      touchStartY.current = e.touches[0].clientY;
      touchEndX.current = e.touches[0].clientX;
      touchEndY.current = e.touches[0].clientY;
    },
    [enabled]
  );

  const onTouchMove = useCallback(
    (e: React.TouchEvent) => {
      if (!isEnabled()) return;
      touchEndX.current = e.touches[0].clientX;
      touchEndY.current = e.touches[0].clientY;
    },
    [enabled]
  );

  const onTouchEnd = useCallback(() => {
    if (!isEnabled()) return;
    const dx = touchStartX.current - touchEndX.current;
    const dy = touchStartY.current - touchEndY.current;
    if (touchStartX.current !== 0 && Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
      onNavigate(dx > 0 ? 1 : -1);
    }
    touchStartX.current = 0;
    touchStartY.current = 0;
    touchEndX.current = 0;
    touchEndY.current = 0;
  }, [enabled, onNavigate, threshold]);

  return { onTouchStart, onTouchMove, onTouchEnd };
}
